import { AbstractEntityCommand } from "../../command";
import { IEditCommand } from "./IEditCommand";

export abstract class AbstractEditEntityCommand<TSource, TEntity> extends AbstractEntityCommand<TSource, TEntity, IEditCommand<TEntity>> implements IEditCommand<TSource> {
  constructor(command: IEditCommand<TEntity>) {
    super(command);
  }

  undo(source: TSource): void {
    this._command.undo(this.toEntity(source));
  }
}
